import { capitalizeFirstLetter } from '@/utils/string';
import { ensureLocale } from '@/utils/urlUtils';

import { BRAND } from '@/lib/const';
import type { Brand } from '@/lib/types';

import logo from '@/assets/breitling.svg';
import logo140 from '@/assets/breitling-140.svg';
import logoWhite from '@/assets/breitling-white.svg';
import logoWhite140 from '@/assets/breitling-white-140.svg';
import galletLogo from '@/assets/gallet-logo.svg';
import galletLogoLine from '@/assets/gallet-logo-line.svg';

type LogoSize = {
  height: number;
  width: number;
};

const logoVariants: {
  [key in Brand]: Record<string, any>;
} = {
  breitling: {
    default: logo,
    logo140: logo140,
    white: logoWhite,
    white140: logoWhite140,
  },
  gallet: {
    default: galletLogo,
    logoLine: galletLogoLine,
  },
};

const logoSizes: {
  [key in Brand]: {
    desktop: Record<string, LogoSize>;
    mobile: Record<string, LogoSize>;
  };
} = {
  breitling: {
    mobile: {
      white140: {
        width: 125,
        height: 32,
      },
      logo140: {
        width: 125,
        height: 32,
      },
      white: {
        width: 89,
        height: 42,
      },
      default: {
        width: 89,
        height: 42,
      },
    },
    desktop: {
      default: {
        width: 203,
        height: 54,
      },
    },
  },
  gallet: {
    mobile: {
      logoLine: {
        width: 201,
        height: 60,
      },
      default: {
        width: 85,
        height: 41,
      },
    },
    desktop: {
      logoLine: {
        width: 268,
        height: 80,
      },
      default: {
        width: 145,
        height: 71,
      },
    },
  },
};

export const getSizes = (variant: string, isMobile: boolean) => {
  const variants = logoSizes[BRAND][isMobile ? 'mobile' : 'desktop'];
  return variants[variant] ?? variants['default'];
};

export const getSrc = (variant: string) => {
  const variants = logoVariants[BRAND];
  return variants[variant] ?? variants['default'];
};

export const getLogoHref = (
  locale: string,
  disableClick?: boolean,
  link?: string | null,
): string => {
  if (disableClick || !link || link === '/') {
    return '/';
  } else {
    return ensureLocale(link, locale) as string;
  }
};

export function getLogoAlt(href: string, disableClick?: boolean) {
  if (href === '/' && !disableClick) {
    return `${capitalizeFirstLetter(BRAND)} home`;
  } else {
    return `${capitalizeFirstLetter(BRAND)} Logo`;
  }
}
